import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Linkedin, Twitter, Instagram, MapPin, Phone, Mail } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#0A0A0A] border-t border-white/10 pt-16 pb-8" data-id="element-45" data-mp="32o4deh7i4k9p">
      <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-46" data-mp="32m1bozwzl2p5">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-47" data-mp="36qhfmvn1i01q">
          {/* Brand Column */}
          <div className="space-y-6" data-id="element-48" data-mp="3ufjuxwu7bgt2">
            <img src="https://cdn.magicpatterns.com/uploads/dpR9DXwCEF7xE6YLwrKxu9/1-offical-logo.png" alt="Sinclair Development" className="h-20 w-auto border-2 border-white rounded-sm" data-id="element-49" data-mp="38qtqszerhoj" />
            <p className="text-white font-serif text-xl" data-id="element-50" data-mp="3qc41189inuk2">Sinclair Develops.</p>
            <p className="text-gray-400 text-sm leading-relaxed" data-id="element-51" data-mp="29yxehh44xsnx">
              We identify opportunities and bring together the planning, design,
              construction and management necessary to turn them into successful
              properties throughout Southwest Florida.
            </p>
            <a href="https://sinclairdevelops.com" className="inline-block text-[#C5A55A] text-sm tracking-[0.15em] uppercase hover:text-[#D4AF37] transition-colors" data-id="element-52" data-mp="3gb8vj0znlauj">
              SinclairDevelops.com
            </a>
          </div>

          {/* Quick Links */}
          <div data-id="element-53" data-mp="828mc4dy418m">
            <h3 className="text-[#C5A55A] font-serif text-lg mb-6" data-id="element-54" data-mp="81pexhlx8v8u">
              Quick Links
            </h3>
            <ul className="space-y-3" data-id="element-55" data-mp="33e4b4nsygpk">
              {['Home', 'About', 'Certifications', 'Contact'].map(item => <li key={item} data-id="element-56" data-mp="huwg0q9mpp34">
                  <Link to={item === 'Home' ? '/' : `/${item.toLowerCase()}`} className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-57" data-mp="ct75rcu8dfg3">
                    {item}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-58" data-mp="twxtpgfxzmch">
            <h3 className="text-[#C5A55A] font-serif text-lg mb-6" data-id="element-59" data-mp="tta0yjibn3yt">
              What We Develop
            </h3>
            <ul className="space-y-3" data-id="element-60" data-mp="13tke644cwbdz">
              <li className="text-gray-400 text-sm" data-id="element-61" data-mp="13sipgwuf3qds">Land Development</li>
              <li className="text-gray-400 text-sm" data-id="element-62" data-mp="18kixlckn5plg">Commercial Development</li>
              <li className="text-gray-400 text-sm" data-id="element-63" data-mp="1clmaprbb17iz">Residential Development</li>
              <li className="text-gray-400 text-sm" data-id="element-64" data-mp="1cnoys5swcql2">Redevelopment</li>
              <li className="text-gray-400 text-sm" data-id="element-65" data-mp="1hje0ofse2jkj">Tenant Improvements</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-66" data-mp="1mhxs2vpr4nka">
            <h3 className="text-[#C5A55A] font-serif text-lg mb-6" data-id="element-67" data-mp="1rile12z4ie7n">
              Contact Us
            </h3>
            <ul className="space-y-4" data-id="element-68" data-mp="3obok97g5r3dc">
              <li className="flex items-start gap-3 text-gray-400 text-sm" data-id="element-69" data-mp="3ocpzlo47ic0v">
                <MapPin className="w-5 h-5 text-[#C5A55A] shrink-0" data-id="element-70" data-mp="3tb9jzk35jfr4" />
                <span data-id="element-71" data-mp="2aevg9zetc08y">
                  1234 Construction Blvd,
                  <br data-id="element-72" data-mp="2ah84gub5z6ug" />
                  Fort Myers, FL 33901
                </span>
              </li>
              <li className="flex items-center gap-3 text-gray-400 text-sm" data-id="element-73" data-mp="25mao12bk1v7j">
                <Phone className="w-5 h-5 text-[#C5A55A] shrink-0" data-id="element-74" data-mp="21nbj3hptpyg3" />
                <a href="tel:239-810-9482" className="hover:text-white transition-colors" data-id="element-75" data-mp="1woi8py5u2nk5">
                  239-810-9482
                </a>
              </li>
              <li className="flex items-center gap-3 text-gray-400 text-sm" data-id="element-76" data-mp="2pdpg7mn9mnhj">
                <Mail className="w-5 h-5 text-[#C5A55A] shrink-0" data-id="element-77" data-mp="2kcrw34ip3jde" />
                <a href="mailto:info@sinclairdevelops.com" className="hover:text-white transition-colors" data-id="element-78" data-mp="2kf4bpb0zdhna">
                  info@sinclairdevelops.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-79" data-mp="2rvzm7cez23t6">
          <p className="text-gray-500 text-xs text-center md:text-left" data-id="element-80" data-mp="2wmppmk3u7wl8">
            © {new Date().getFullYear()} Sinclair Development. All rights
            reserved.
            <span className="mx-2 text-white/20" data-id="element-81" data-mp="2nu5nvas91bw6">|</span>
            <span className="text-[#C5A55A] tracking-wider" data-id="element-82" data-mp="2nunsaup2ewf6">
              FL License #CGC1541661
            </span>
          </p>
          <div className="flex items-center gap-4" data-id="element-83" data-mp="3bhvydeubi9i9">
            <a href="#" className="text-gray-500 hover:text-[#C5A55A] transition-colors" data-id="element-84" data-mp="3fkah7yxzl99j">
              <Facebook className="w-4 h-4" data-id="element-85" data-mp="31laoaf3fy87k" />
            </a>
            <a href="#" className="text-gray-500 hover:text-[#C5A55A] transition-colors" data-id="element-86" data-mp="36jknd0sadsyg">
              <Twitter className="w-4 h-4" data-id="element-87" data-mp="1q52mwgzqx2xh" />
            </a>
            <a href="#" className="text-gray-500 hover:text-[#C5A55A] transition-colors" data-id="element-88" data-mp="1v5qlpou7uo29">
              <Linkedin className="w-4 h-4" data-id="element-89" data-mp="1nkeg2ttys001" />
            </a>
            <a href="#" className="text-gray-500 hover:text-[#C5A55A] transition-colors" data-id="element-90" data-mp="1inny20ylmubz">
              <Instagram className="w-4 h-4" data-id="element-91" data-mp="1wm43zpon0gt2" />
            </a>
          </div>
        </div>
      </div>
    </footer>;
}